import * as React from "react";
import { Switch as AntSwitch} from 'antd';
import fieldProps from "./fieldProps";

@fieldProps
export default class Switch extends React.Component {
  render(){
    const {value,onChange} =  this.props
    return (
      <AntSwitch checked={value} onChange={(checked)=>onChange(checked)} />
    )
  }
}
